import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

// ==================== EVENTS (CRUD) ====================
async function getList(params?: any) {
  const response = await http
    .getDataParam("/mutu/komplain/events", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/mutu/komplain/events/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/mutu/komplain/events", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/mutu/komplain/events/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/mutu/komplain/events/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function submit(id: number, data: any) {
  const response = await http
    .postData(`/mutu/komplain/events/${id}/submit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== 3-TIER SIGN ====================
async function signKaUnit(
  id: number,
  data: { password: string; grading_final_override?: string; grading_change_reason?: string }
) {
  const response = await http
    .postData(`/mutu/komplain/events/${id}/sign-ka-unit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKomiteMutu(id: number, data: { password: string }) {
  const response = await http
    .postData(`/mutu/komplain/events/${id}/sign-komite-mutu`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== PREVIEW STATUS ====================
async function previewStatus(params: { grading: string; t0: string; t1?: string }) {
  const response = await http
    .getDataParam("/mutu/komplain/preview-status", { params })
    .catch(err => {
      return Promise.reject(err);
    });
  return response;
}

// ==================== RTL ====================
async function updateRtlStatus(id: number, data: { rtl_status: string; rtl_bukti_implementasi?: any[] }) {
  const response = await http
    .postData(`/mutu/komplain/events/${id}/rtl-status`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== DASHBOARD & REKAP ====================
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam("/mutu/komplain/dashboard", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getRekapHarian(params?: any) {
  const response = await http
    .getDataParam("/mutu/komplain/rekap-harian", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== MONTHLY REPORT ====================
async function getMonthly(tahun: number, bulan: number) {
  const response = await http
    .getData(`/mutu/komplain/monthly/${tahun}/${bulan}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function finalizeMonthly(tahun: number, bulan: number, data: any) {
  const response = await http
    .postData(`/mutu/komplain/monthly/${tahun}/${bulan}/finalize`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function triggerAggregate(tahun: number, bulan: number) {
  const response = await http
    .postData(`/mutu/komplain/monthly/${tahun}/${bulan}/trigger-aggregate`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== PDF ====================
function printPdf(id: number) {
  window.open(`${http.getAPI()}/mutu/komplain/events/${id}/pdf`, "_blank");
}

function printRekapHarianPdf(params: { tanggal: string; unit_id?: string }) {
  const qs = new URLSearchParams(params as any).toString();
  window.open(`${http.getAPI()}/mutu/komplain/rekap-harian/pdf?${qs}`, "_blank");
}

function printMonthlyPdf(tahun: number, bulan: number) {
  window.open(`${http.getAPI()}/mutu/komplain/monthly/${tahun}/${bulan}/pdf`, "_blank");
}

export default {
  getList,
  find,
  create,
  update,
  destroy,
  submit,
  signKaUnit,
  signKomiteMutu,
  previewStatus,
  updateRtlStatus,
  getDashboard,
  getRekapHarian,
  getMonthly,
  finalizeMonthly,
  triggerAggregate,
  printPdf,
  printRekapHarianPdf,
  printMonthlyPdf,
};
